"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAB_TIER_LABELS_FR = exports.TAB_TIER_LABELS = exports.TAB_TIER_IDS = exports.ORDER_TYPES = exports.PROVINCE = exports.LANGUAGE = void 0;
exports.LANGUAGE = {
    EN: 'en',
    FR: 'fr'
};
exports.PROVINCE = {
    ON: 'on',
    BC: 'bc',
    QC: 'qc',
    AB: 'ab',
    NB: 'nb',
    NS: 'ns',
    PE: 'pe',
    YT: 'yt',
    NL: 'nl',
    NU: 'nu',
    MB: 'mb',
    NT: 'nt',
    SK: 'sk'
};
exports.ORDER_TYPES = {
    ACTIVATION: 'ACTIVATION',
    RENEWAL: 'RENEWAL',
    AAL: 'AAL'
};
exports.TAB_TIER_IDS = {
    BRING_YOUR_OWN_PHONE: '6000',
    NO_TAB: '6001',
    TAB_BASIC: '6002',
    TAB_PLUS: '6003',
    TAB_MID: '6004',
    TAB_LITE: '6011'
};
exports.TAB_TIER_LABELS = {
    BRING_YOUR_OWN_PHONE: 'Bring your own phone',
    NO_TAB: 'No Tab',
    TAB_BASIC: 'Tab Basic',
    TAB_PLUS: 'Tab Plus',
    TAB_MID: 'Tab Mid',
    TAB_LITE: 'Tab Lite'
};
exports.TAB_TIER_LABELS_FR = {
    BRING_YOUR_OWN_PHONE: 'Utiliser mon téléphone',
    NO_TAB: 'Prix annoncé',
    TAB_BASIC: 'Balance de base',
    TAB_PLUS: 'Balance extra',
    TAB_MID: 'Balance intermédiaire',
    TAB_LITE: 'Balance de départ'
};
//# sourceMappingURL=constants.js.map